import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  CbButtonModule,
  CbCurrencyModule,
  CbInputModule,
  CbSelectChoiceModule,
  CbToggleModule,
} from '@chubb/ui-components';
import { CbModalModule } from '@chubb/ui-components/cb-modal';
import { SelectModule } from 'primeng/select';
import { BaseCoverageWidgetComponent } from '../../../../shared/components/base-coverage.widget.component';
import { RemoveCoverComponent } from '../../remove-cover/remove-cover.component';
import { RulesErrorCoverageComponent } from '../../rules-error-coverage/rules-error-coverage.component';
import { UnderwritingTermsComponent } from '../../underwriting-terms/underwriting-terms.component';

@Component({
  selector: 'app-mortgage-repayment-cover',
  imports: [
    CommonModule,
    CbCurrencyModule,
    CbButtonModule,
    CbInputModule,
    CbSelectChoiceModule,
    SelectModule,
    CbToggleModule,
    CbModalModule,
    ReactiveFormsModule,
    UnderwritingTermsComponent,
    RemoveCoverComponent,
    RulesErrorCoverageComponent,
  ],
  templateUrl: './mortgage-repayment-cover.component.html',
  styleUrl: './mortgage-repayment-cover.component.scss',
})
export class MortgageRepaymentCoverComponent extends BaseCoverageWidgetComponent {}
